export default __webpack_public_path__ + "static/media/FC-Iconic-Regular.203b6ffd.ttf";